import template from './groupTypeahead.html';

const groupTypeahead = {
  template,
  bindings: {
    onUpdate: '&',
    onClear: '&',
    required: '<',
    initialGroupId: '@?',
    blur: '&',
    focus: '=',
    disabled: '<',
    name: '@',
    hasLabel: '<',
    model: '='
  },
  controller: [
    'groupsService',
    function GroupTypeaheadCtrl(groupsService) {
      this.$onInit = () => {
        const initialGroupId = this.initialGroupId;
        if (initialGroupId) {
          groupsService.convertIdToName(initialGroupId).then((groupName) => {
            this.model = {
              displayName: groupName,
              id: initialGroupId
            };
          });
        }
      };

      groupsService.getGroups()
        .then((data) => {
          this.groups = data;
        });

      this.setGroup = (group) => {
        this.onUpdate({ id: group });
      };

      this.removeGroup = () => {
        const emptyGroup = null;
        this.model = emptyGroup;
        this.onClear({ id: emptyGroup });
      };
    }
  ]
};

export default function (ngModule) {
  ngModule.component('groupTypeahead', groupTypeahead);
}
